import {
    SET_USER_INFO,
    SET_IS_IN_TEAMS,
    SET_ACCESS_TOKEN,
    SET_TOKEN_ERROR
} from '../actions/types';

import { FETCH_USERS_SUCCESS, FETCH_USERS_FAIL } from "../actions/types";

const initialState = {
    userInfo: null,
    isInTeams: false,
    accessToken: null,
    tokenError: null,

    users: [],
    loading: true,
};

export default function userReducer(state = initialState, action) {
    switch (action.type) {
        case SET_USER_INFO:
            return { ...state, userInfo: action.payload };
        case SET_IS_IN_TEAMS:
            return { ...state, isInTeams: action.payload };
        case SET_ACCESS_TOKEN:
            return { ...state, accessToken: action.payload };
        case SET_TOKEN_ERROR:
            return { ...state, tokenError: action.payload };

        case FETCH_USERS_SUCCESS:
            return { ...state, users: action.payload, loading: false };
        case FETCH_USERS_FAIL:
            return { ...state, users: [], loading: false };

        default:
            return state;
    }
}
